module.exports = __webpack_public_path__ + "static/img/port.29a3bac.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/index/port.png
// module id = 2dYH
// module chunks = 0